import './NotificationText.scss';

import React from 'react';
import { handleTextStyleForTransfer } from '../helpers';
import classNames from 'classnames';
import { NotificationData } from '../notifications-types';
import { NotificationStatus } from '../data';

export type NotificationTextProps = {
  notificationData: NotificationData;
};

export default function NotificationText({ notificationData }: NotificationTextProps) {
  const textStyle = handleTextStyleForTransfer(notificationData.text);
  if (textStyle.hasTransferText) {
    return (
      <span>
        <b>{textStyle.boldText}</b> transferred you a form {textStyle.normalText}
      </span>
    );
  } else {
    return <span className={classNames('notification-text', { failed: notificationData.status === NotificationStatus.Error })}>{textStyle.text}</span>;
  }
}
